import MusicNoteIcon from '@mui/icons-material/MusicNote'
import HomeIcon from '@mui/icons-material/Home'
import CodeIcon from '@mui/icons-material/Code'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'
import LiveTvIcon from '@mui/icons-material/LiveTv'
import SchoolIcon from '@mui/icons-material/School'
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural'
import CheckroomIcon from '@mui/icons-material/Checkroom'
import GraphicEqIcon from '@mui/icons-material/GraphicEq'
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy'
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter'
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode'
import demoThumbnailUrl from './hq720.webp'

export const logo = 'https://i.ibb.co/s9Qys2j/logo.png'

export const categories = [
  { name: 'New', icon: <HomeIcon /> },
  { name: 'Coding', icon: <CodeIcon /> },
  { name: 'ReactJS', icon: <CodeIcon /> },
  { name: 'NextJS', icon: <CodeIcon /> },
  { name: 'VueJS', icon: <CodeIcon /> },
  { name: 'Music', icon: <MusicNoteIcon /> },
  { name: 'Education', icon: <SchoolIcon /> },
  { name: 'Podcast', icon: <GraphicEqIcon /> },
  { name: 'Movie', icon: <OndemandVideoIcon /> },
  { name: 'Gaming', icon: <SportsEsportsIcon /> },
  { name: 'Live', icon: <LiveTvIcon /> },
  { name: 'Sport', icon: <FitnessCenterIcon /> },
  { name: 'Fashion', icon: <CheckroomIcon /> },
  { name: 'Beauty', icon: <FaceRetouchingNaturalIcon /> },
  { name: 'Comedy', icon: <TheaterComedyIcon /> },
  { name: 'Gym', icon: <FitnessCenterIcon /> },
  { name: 'Crypto', icon: <DeveloperModeIcon /> },
]

export { demoThumbnailUrl }
export const demoChannelUrl = '/channel/UCuAXFkgsw1L7xaCfnd5JJOw'
export const demoVideoUrl = '/video/dQw4w9WgXcQ'
export const demoChannelTitle = 'Rickroll'
export const demoVideoTitle =
  'Rick Astley - Never Gonna Give You Up (Official Music Video)'
export const demoProfilePicture =
  'http://dergipark.org.tr/assets/app/images/buddy_sample.png'
